import { useState } from 'react';

import { useAuth } from '../../context/AuthContext';

export default function SignupView({ onSwitch, onSuccess }) {
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    setSubmitting(true);
    try {
      await register({ name, email, password });
      onSuccess();
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="auth-panel" onSubmit={handleSubmit} noValidate>
      <h2 className="auth-title">Create account</h2>
      <p className="auth-sub">Join FleshLight VIP for free</p>

      {error && <div className="auth-error">{error}</div>}

      <div className="field">
        <label htmlFor="signup-name">Name</label>
        <input
          type="text"
          id="signup-name"
          placeholder="Your name"
          autoComplete="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="field">
        <label htmlFor="signup-email">Email</label>
        <input
          type="email"
          id="signup-email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label htmlFor="signup-password">Password</label>
        <input
          type="password"
          id="signup-password"
          placeholder="Min. 8 characters"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button className="auth-submit" type="submit" disabled={submitting}>
        {submitting ? 'Creating account…' : 'Create Account'}
      </button>

      <p className="auth-switch">
        Already have an account?{' '}
        <a href="#login" onClick={(e) => { e.preventDefault(); onSwitch('login'); }}>
          Log in
        </a>
      </p>
    </form>
  );
}
